import { render } from "./Dashboard.vue?vue&type=template&id=0f9150ce&scoped=true&ts=true"
import script from "./Dashboard.ts?vue&type=script&lang=ts"
export * from "./Dashboard.ts?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=0f9150ce&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetalRO\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9150ce"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QIcon,QImg,QBadge});qInstall(script, 'directives', {Ripple});
